import { useEffect, useRef } from 'react';
import { css, keyframes } from '@emotion/react';
import { Animation, Colors, Shadows, Zindexes } from '../../../theme';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { useClickOutside, useIntersect } from '../../../hooks';
const menuOpenAnimation = keyframes({
    '0%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '30%': {
        transform: 'translateY(-10px)',
        opacity: 0,
    },
    '100%': {
        transform: 'translateY(0)',
        opacity: 1,
    },
});
const DISTANCE = 'calc(100% + 5px)';
const Styles = labelStyles('FloatingBox', {
    root: (props, derivedState) => [
        css({
            animation: `${Animation.transitionDuration} ease-out ${menuOpenAnimation}`,
            maxWidth: props.maxWidth,
            position: 'absolute',
            minWidth: props.minWidth,
            zIndex: Zindexes.dropdownMenu,
        }),
        props.align === 'left' &&
            withModifier(props.align, {
                left: 0,
            }),
        props.align === 'right' &&
            withModifier(props.align, {
                right: 0,
            }),
        props.align === 'stretch' &&
            withModifier(props.align, {
                left: 0,
                right: 0,
            }),
        derivedState.position === 'south' &&
            withModifier(derivedState.position, {
                top: DISTANCE,
            }),
        derivedState.position === 'north' &&
            withModifier(derivedState.position, {
                bottom: DISTANCE,
            }),
    ],
    box: (backgroundColor, borderRadius, borderColor) => css({
        backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius,
        boxShadow: Shadows.elevation20,
    }),
});
function getBackgroundColor(hasWhiteBackground = false) {
    return hasWhiteBackground ? Colors.white : Colors.neutral100;
}
export const FloatingBox = ({ children, hasWhiteBackground = undefined, intersectHeight = undefined, maxWidth = undefined, minWidth = undefined, onClickOutside = () => { }, align = 'left', position = undefined, borderRadius = 3, borderColor = Colors.neutral400, }) => {
    const threshold = 0.9;
    const node = useRef(null);
    const [setIntersectNode, { isBottomIntersecting, isTopIntersecting }] = useIntersect({
        heightOverride: intersectHeight,
        once: true,
        threshold,
    });
    const backgroundColor = getBackgroundColor(hasWhiteBackground);
    const [setClickOutsideNode] = useClickOutside({
        onClickOutside,
    });
    useEffect(() => {
        setIntersectNode(node.current);
        setClickOutsideNode(node.current);
    }, [setClickOutsideNode, setIntersectNode]);
    const derivedState = {
        position: position ||
            (isTopIntersecting || !isBottomIntersecting ? 'south' : 'north'),
    };
    return (isolateComponent("div", { css: Styles.root({ maxWidth, minWidth, align }, derivedState), ref: node, "data-testid": "floating-box" },
        isolateComponent("div", { css: Styles.box(backgroundColor, borderRadius, borderColor) }, children)));
};
//# sourceMappingURL=FloatingBox.js.map
// @zapier/design-system@6.27.0 (617a97f69)
